export default function Sidebar({ activePage, setActivePage, onLogout, userRole }) {
  var role = userRole || 'super_admin';

  var allItems = [
    { id: 'dashboard',  label: '\u{1F4CA} Dashboard',          roles: ['super_admin', 'manager', 'support'] },
    { id: 'customers',  label: '\u{1F6D2} Customers',          roles: ['super_admin', 'manager'] },
    { id: 'users',      label: '\u{1F465} Users',              roles: ['super_admin'] },
    { id: 'workers',    label: '\u{1F527} Workers',            roles: ['super_admin', 'manager'] },
    { id: 'bookings',   label: '\u{1F4CB} Bookings',           roles: ['super_admin', 'manager', 'support'] },
    { id: 'services',   label: '\u{1F6E0} Services',           roles: ['super_admin', 'manager'] },
    { id: 'categories', label: '\u{1F4C2} Categories',         roles: ['super_admin', 'manager'] },
    { id: 'payments',   label: '\u{1F4B3} Payments',           roles: ['super_admin'] },
    { id: 'tickets',    label: '\u{1F3AB} Tickets',            roles: ['super_admin', 'manager', 'support'] },
    { id: 'reviews',    label: '\u{2B50} Reviews',             roles: ['super_admin', 'manager'] },
    { id: 'branding',   label: '\u{1F3A8} Branding',           roles: ['super_admin'] },
    { id: 'staff',      label: '\u{1F464} Staff',              roles: ['super_admin'] },
    { id: 'service_areas', label: '\u{1F4CD} Service Areas',     roles: ['super_admin', 'manager'] },
    { id: 'map_view',      label: '\u{1F5FA} Map View',            roles: ['super_admin', 'manager'] },
    { id: 'promos',        label: '\u{1F3A0} Promo Slides',        roles: ['super_admin', 'manager'] },
    { id: 'announcements', label: '\u{1F4E2} Announcements',       roles: ['super_admin', 'manager'] },
    { id: 'analytics',     label: '\u{1F4CA} Analytics',           roles: ['super_admin', 'manager', 'franchise'] },
  ];

  var navItems = allItems.filter(function(item) { return item.roles.indexOf(role) >= 0; });

  return (
    <div className="sidebar">
      <div className="sidebar-logo">
        <h2>HomeChamp</h2>
        <p>Admin Panel</p>
      </div>
      <nav className="sidebar-nav" style={{overflowY: 'auto', flex: 1, scrollbarWidth: 'thin'}}>
        {navItems.map(function(item) {
          return (
            <div
              key={item.id}
              className={'nav-item ' + (activePage === item.id ? 'active' : '')}
              onClick={function() { setActivePage(item.id); }}
            >
              {item.label}
            </div>
          );
        })}
      </nav>
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={onLogout}>Logout</button>
      </div>
    </div>
  );
}
